import React, { ReactNode, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import CloseSVG from '../../images/close.svg';
import { CERULEAN } from '../../@style/colors';
import Portal from '../portal';
import screens from '../../@style/screens';

export interface Props {
  children: ReactNode;
  show: boolean;
  onClose: () => void;
}

const StyledModal = styled.div`
  background-color: hsla(0, 0%, 43%, 0.5);
  justify-content: right;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 50;
  bottom: 0;
  left: 0;
  top: 0;
  position: fixed;
`;

const StyledContainer = styled.div`
  background: radial-gradient(circle, rgba(1,33,105,1) 0%, rgba(1,17,53,1) 100%) !important;
  height: 100%;
  width: 100%;
  padding: 2rem 0;
  max-width: 100vw;
  overflow-y: auto;
  @media ${screens.laptop} {
    width: 40%;
    border-left: 2px solid ${CERULEAN};
    padding: 30px;
  }
`;

const CloseButton = styled(CloseSVG)`
  cursor: pointer;
  width: 26px;
  height: 26px;
  position: absolute;
  margin-right: 50px;
  right: 0;
`;

const Modal: React.FC<Props> = ({ children, onClose, show }) => {
  const escFunction = useCallback(
    (event: { keyCode: number }) => {
      if (event.keyCode === 27 && show) {
        onClose();
      }
    },
    [onClose, show]
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  if (!show) {
    return null;
  }

  return (
    <Portal>
      <StyledModal>
        <StyledContainer>
          <CloseButton onClick={onClose} />
          {children}
        </StyledContainer>
      </StyledModal>
    </Portal>
  );
};

export default Modal;
